import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { QUICK_SWITCH_ACCOUNT } from '../graphql/mutations';

export const useDevSettings = () => {
   const navigate = useNavigate();
   const [quickSwitchAccount] = useMutation(QUICK_SWITCH_ACCOUNT);

   const handleQuickSwitch = async (account) => {
      try {
         const { data } = await quickSwitchAccount({
            variables: {
               username: account.username,
               password: account.password
            }
         });

         if (data.quickSwitchAccount) {
            const { token, user } = data.quickSwitchAccount;

            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify({
               id: user.id,
               username: user.username,
               firstName: user.firstName,
               lastName: user.lastName,
               roles: user.roles
            }));

            toast.success(`Switched to ${account.label}`);

            if (user.roles.includes('superadmin')) {
               navigate('/superadmin/dashboard');
            } else if (user.roles.includes('user')) {
               navigate('/applicationsStatus');
            } else if (user.roles.some(role => [
               'Chief_RPS',
               'Chief_TSD',
               'Technical_Staff',
               'Forest_Ranger',
               'Bill_Collector',
               'PENR_CENR_Officer',
               'Releasing_Clerk'
            ].includes(role))) {
               navigate('/personnel/dashboard');
            }
         }
      } catch (error) {
         toast.error('Failed to switch account');
         console.error('Switch account error:', error);
      }
   };

   const toggleMockFinancialData = (enabled) => {
      localStorage.setItem('useMockFinancialData', enabled.toString());
      toast.success(`Mock financial data ${enabled ? 'enabled' : 'disabled'}`, {
         description: `Financial analytics will now use ${enabled ? 'mock' : 'real'} data`
      });
   };

   const isMockFinancialDataEnabled = () => {
      return localStorage.getItem('useMockFinancialData') === 'true';
   };

   return {
      handleQuickSwitch,
      toggleMockFinancialData,
      isMockFinancialDataEnabled
   };
};